/**
 * Every room you can walk into. Each is one file exporting `room` (its
 * RoomDef, with a door portal back to 'town') and `npcs`. To add one: write
 * the file, add its id to `RoomId` in defs.ts, register it here, and give a
 * building in some district `enter: '<id>'`. The door is wired automatically.
 */
import type { Npc, RoomDef, RoomId } from '../defs.ts'
import * as arcade from './arcade.ts'
import * as cafe from './cafe.ts'
import * as hatshop from './hatshop.ts'
import * as lotus from './lotus.ts'
import * as teahouse from './teahouse.ts'

export const INTERIORS: Array<{ room: RoomDef; npcs: Npc[] }> = [cafe, arcade, hatshop, teahouse, lotus]

export const INTERIOR_NAMES: Partial<Record<RoomId, string>> = Object.fromEntries(INTERIORS.map((i) => [i.room.id, i.room.name]))
